<script>
  import Toast from "./Toast.svelte";
  export let items = [];
</script>

{#if items}
  <section>
    {#each items as item}
      {#if item.errors && item.errors.length > 0}
        {#each item.errors as error}
          <Toast {error} title={item.title} />
        {/each}
      {/if}
    {/each}
  </section>
{/if}

<style>
  section {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    display: flex;
    margin-top: 1rem;
    justify-content: center;
    flex-direction: column;
    z-index: 1000;
  }
</style>
